import { Component, inject, Input } from '@angular/core';
import { DocumentService } from '../../document.service';
import { LoadingController, ToastController } from '@ionic/angular';

@Component({
    selector: 'app-document-download-button',
    templateUrl: './document-download-button.component.html',
    styleUrls: ['./document-download-button.component.scss'],
    standalone: false
})
export class DocumentDownloadButtonComponent {

    @Input() public downloadButtonText: string = 'Download';
    @Input() public url: string | null = null;
    @Input() public fill: string = 'default';
    @Input() public disabled: boolean = false;

    private readonly documentService: DocumentService = inject(DocumentService);
    private readonly toastController: ToastController = inject(ToastController);
    private readonly loadingCOntroller: LoadingController = inject(LoadingController);

    public async downloadDocument(): Promise<void> {

        if (this.url == null) {
            console.warn('URL for download button is null');
            return;
        }

        const loader = await this.loadingCOntroller.create({
            message: 'Document aan het ophalen van de server...',
            spinner: 'crescent'
        });

        try {
            await loader.present();
            console.log('starting download of document');

            await this.documentService.downloadDocumentWithToken(this.url);

        } catch (e) {
            console.error('Error downloading document:', e);

            const errorToast = await this.toastController.create({
                    message: 'Er is iets misgegaan bij het downloaden van het bestand. Probeer het later nog eens.',
                    duration: 5000,
                    color: 'danger',
                    position: 'bottom'
                }
            );
            await errorToast.present();

        } finally {
            await loader.dismiss();
        }
    }

}
